import { ContentAttributeDto, ContentDto, ContentWidgetDto, EContentLocation, EContentViewType, IContentDto } from "projects/shared/lib/services/INTEGRA_Shop_Client";

export class Content implements IContentDto {
  public parent?: string | undefined;
  public location!: EContentLocation;
  public viewType: EContentViewType;
  public sequence: number;
  public contentAttributeList?: ContentAttributeDto[] | undefined;
  public contentWidgetList?: ContentWidgetDto[] | undefined;

  public hostClass: string | undefined;
  public widgetColumnClass: string | undefined;
  public id: string | undefined;
  public class: string | undefined;

  constructor(data?: Content | ContentDto) {
    this.viewType = EContentViewType.Default;
    this.sequence = 0;

    if (data != undefined) {
      this.parent = data.parent;
      this.location = data.location;
      this.viewType = data.viewType;
      this.sequence = data.sequence;
      this.contentAttributeList = data.contentAttributeList;
      this.contentWidgetList = data.contentWidgetList?.sort((a, b) => a.sequence - b.sequence);
    }
  }
}
